/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpRespSimilarItem_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespSimilarItemsGrid_user$ref: FragmentReference;
export type PdpRespSimilarItemsGrid_user = {|
  +serviceId: ?string,
  +$fragmentRefs: PdpRespSimilarItem_user$ref,
  +$refType: PdpRespSimilarItemsGrid_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespSimilarItemsGrid_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItem_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'f75bd8f8dbfd2cf0c25719e068ba0cbd';
module.exports = node;
